import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomerAddress } from '../../../../modules/backend/openapi/api-types';
import { DefinitionList } from '../../../../visual-components/definition-list/definition-list';
import { DefinitionBasic } from '../../../../visual-components/definition-list/definition-renderers/definition-basic/definition-basic';

type Props = {
  address: CustomerAddress;
  title: string;
};

export const Address: React.FC<Props> = ({ address, title }) => {
  const { t } = useTranslation();

  return (
    <DefinitionList title={title}>
      <DefinitionBasic term={t('form.id.name')}>{address.name1}</DefinitionBasic>
      {address.name2 ? (
        <DefinitionBasic term={t('profile.address.additionalName', { addition: 1 })}>{address.name2}</DefinitionBasic>
      ) : null}
      {address.name3 ? (
        <DefinitionBasic term={t('profile.address.additionalName', { addition: 2 })}>{address.name3}</DefinitionBasic>
      ) : null}
      {address.name4 ? (
        <DefinitionBasic term={t('profile.address.additionalName', { addition: 3 })}>{address.name4}</DefinitionBasic>
      ) : null}
      <DefinitionBasic term={t('form.id.street')}>{address.streetAndHouseNo}</DefinitionBasic>
      <DefinitionBasic term={t('form.id.postal')}>{address.zip}</DefinitionBasic>
      <DefinitionBasic term={t('form.id.city')}>{address.city}</DefinitionBasic>
      <DefinitionBasic term={t('form.id.country')}>{address.country}</DefinitionBasic>
    </DefinitionList>
  );
};
